import { render, staticRenderFns } from "./ChatbotConversations.vue?vue&type=template&id=54e376e8&scoped=true"
import script from "./ChatbotConversations.vue?vue&type=script&lang=js"
export * from "./ChatbotConversations.vue?vue&type=script&lang=js"
import style0 from "./ChatbotConversations.vue?vue&type=style&index=0&id=54e376e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e376e8",
  null
  
)

export default component.exports